import { http } from './config/config-receituario'

export default {
  /**
   * Consulta produto pelo número de registro
   * @param {string} token
   * @param {string|number} numeroRegistro
   */
  register: (token, numeroRegistro) => {
    return http.get(
      `newprod?numero_registro=${encodeURIComponent(numeroRegistro)}`,
      {
        headers: {
          'Authorization': token
        }
      }
    )
  }
}
